import { css } from '@emotion/react';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('TableLabel', ['label']);

const getTableLabelCss = css`
  margin-bottom: var(--cds-spacing-400);
  text-align: start;
  max-width: 100vw;

  &.${classes.label} {
    margin-bottom: var(--cds-spacing-50);
  }
`;

export default getTableLabelCss;
